import { put, select, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import MatchConfidenceLevel from '../../../../Data/MatchConfidenceLevel';
import { setMatchConfidence } from '../../slices/supplierMatches';
import { calculateConfidenceLevel } from '../../../../Helpers/matchConfidence';
import { exposeMatchConfidenceLevelChangedEvent } from '../../../../Helpers/events';

export function* updateMatchConfidenceWorker() {
  const {
    components,
    supplierMatches,
    features,
    formConfig,
    newsletter,
    optionalFormConfig,
  } = yield select();
  const { showSmartMatchMeter, showSmartMatchMeterV2 } = features || {};
  const { iFrameId } = optionalFormConfig || {};

  if (!showSmartMatchMeter && !showSmartMatchMeterV2) {
    return;
  }

  // Get parameters needed for visibility checking
  const dynamicNewsletterName = newsletter?.dynamicNewsletterName || null;
  const phoneNumberCountryCode = formConfig?.phoneNumberCountryCode || null;
  const subcategoryId = formConfig?.subcategoryId || null;

  const confidenceLevel = calculateConfidenceLevel(
    components,
    dynamicNewsletterName,
    phoneNumberCountryCode,
    subcategoryId
  );

  const previousLevel = supplierMatches?.matchConfidence?.confidenceLevel;

  // Preserve lastShownLevel - only update when confidenceLevel is not NULL
  // This ensures we track the last actual level shown to the user
  const lastShownLevel =
    confidenceLevel !== MatchConfidenceLevel.NULL
      ? confidenceLevel
      : supplierMatches?.matchConfidence?.lastShownLevel ||
        MatchConfidenceLevel.NULL;

  yield put(
    setMatchConfidence({
      confidenceLevel,
      lastShownLevel,
    })
  );

  // Publish event if confidence level changed
  if (previousLevel !== confidenceLevel) {
    exposeMatchConfidenceLevelChangedEvent({
      confidenceLevel, // External API uses confidenceLevel
      previousLevel,
      iFrameId,
    });
  }
}

export default function* updateMatchConfidenceWatcher() {
  yield takeEvery(
    ActionTypes.HANDLE_ANSWER_QUESTION_SIDE_EFFECTS_COMPLETED,
    updateMatchConfidenceWorker
  );
  yield takeEvery('NAVIGATION/pageChange', updateMatchConfidenceWorker);
}
